<template>
    <div
        v-if="visible"
        class="navigation-progress"
        role="progressbar"
        aria-label="Loading page"
        aria-busy="true"
    >
        <div class="navigation-progress__bar"></div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { navigationProgress } from "@/util/navigationProgress";

// A thin bar along the top of the window while a navigation waits on the network. The page being
// left stays on screen until the next one is ready, so without this a slow load looks like a dead click.
@Component({ name: "NavigationProgressBar" })
export default class NavigationProgressBar extends Vue {
    get visible(): boolean {
        return navigationProgress.visible;
    }
}
</script>

<style lang="scss" scoped>
.navigation-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    z-index: 1100;
    overflow: hidden;
    pointer-events: none;
}

.navigation-progress__bar {
    width: 40%;
    height: 100%;
    background: var(--primary, #007bff);
    animation: navigation-progress-slide 1.1s ease-in-out infinite;
}

@keyframes navigation-progress-slide {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(250%);
    }
}

@media (prefers-reduced-motion: reduce) {
    .navigation-progress__bar {
        width: 100%;
        animation: none;
        opacity: 0.6;
    }
}
</style>
